module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center text-center center-lg"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xs-12"
  }, [_c('div', {
    staticClass: "container-fluid text-center"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "https://www.facebook.com/workteen/",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "https://twitter.com/teen_work?lang=en",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "mailto:opportunities.workteen@outlook.com",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "http://www.workteen.org",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-12 col-xs-12"
  }, [_c('strong', [_c('p', {
    staticStyle: {
      "margin-top": "3%",
      "font-size": "1.2em"
    }
  }, [_vm._v("Made with "), _c('icon', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "red"
    },
    attrs: {
      "name": "heart",
      "scale": "1"
    }
  }), _vm._v(" by the WorkTeen Team.")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-12 col-xs-12"
  }, [_c('strong', [_c('p', {
    staticStyle: {
      "margin-top": "6%",
      "font-size": "1.5em"
    }
  }, [_vm._v("Thoughts? Connect with us.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4913f3d7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 896
// module chunks = 1